import React from 'react'
// libs
import { submit } from 'redux-form'
import { useDispatch } from 'react-redux'
// components
import AppetiteOptionsForm from './components/Form'
import { Button, BUTTON_LAYOUTS, Modal } from 'components/UI'
// hooks
import { useModalData } from 'hooks/index'
// constants
import { Forms, Modals } from 'constants/index'
import { COMPARISON_OPTIONS } from 'components/Modals/AppetiteOptionsModal/components/Form/components/AppetiteOption'
// views
import { Header, Container, ButtonsContainer } from './views'
// types
import {
  MatrixOption,
  MatrixAppetite,
  MatrixAppetiteOption
} from 'components/Modals/MatrixModal/components/Matrix/types'
// utils
import isNumber from 'lodash/isNumber'
import { getOptionByValue, getValueFromOption } from 'utils/form'

interface Props {
  onSave: (options: MatrixAppetiteOption[], idx: number) => void
  matrixOptions: MatrixOption[]
  initialOptions: MatrixAppetite[]
}

const AppetiteOptionsModal: React.FC<Props> = ({ onSave, matrixOptions, initialOptions }) => {
  const dispatch = useDispatch()

  const {
    hideModal,
    modalData: { isOpen = false, optionIdx }
  } = useModalData({ modalType: Modals.RISK_MATRIX_APPETITE_OPTIONS_MODAL })

  const onSubmit = (data) => {
    onSave(
      data.options.map((item) => ({
        ...item,
        matrixOptionId: getValueFromOption(item.matrixOptionId),
        comparisonType: getValueFromOption(item.comparisonType)
      })),
      optionIdx
    )

    hideModal()
  }

  const onSaveClick = () => dispatch(submit(Forms.RISK_MATRIX_APPETITE_FORM))

  const matrixValuesOptions = matrixOptions.map((item) => ({
    value: item.id,
    label: isNumber(parseFloat(item.value)) ? `${item.label} (${item.value})` : item.label
  }))

  const initialValues = {
    options:
      initialOptions
        ?.find((_i, idx) => idx === optionIdx)
        ?.options?.map((option) => ({
          ...option,
          matrixOptionId: getOptionByValue(option.matrixOptionId, matrixValuesOptions),
          comparisonType: getOptionByValue(option.comparisonType, COMPARISON_OPTIONS)
        })) || []
  }

  return (
    <Modal isOpen={isOpen} width='md' hideModal={hideModal}>
      <Container>
        <Header>
          <span>Level selected us</span> <span>Display message</span> <span>Alert color</span>
        </Header>
        <AppetiteOptionsForm matrixOptions={matrixValuesOptions} onSubmit={onSubmit} initialValues={initialValues} />
        <ButtonsContainer>
          <Button shadowLess type='button' onClick={onSaveClick} layout={BUTTON_LAYOUTS.PURPLE}>
            Save
          </Button>
          <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={hideModal}>
            Cancel
          </Button>
        </ButtonsContainer>
      </Container>
    </Modal>
  )
}

export default AppetiteOptionsModal
